import axios from "axios"
import { ApiUrls } from '../../constants/Activation/apiUrls';
import { getTransactionId } from "../transactionId";

/**
 * call api to activate user account
 * @param   {object} payload  Api payload consisting of activationToken, activationId, productId, phone number, password and preferred language
 * @return  {object}          Api response
 */
export const postAccountActivation = (payload, token) =>
{
  const url = ApiUrls.activation.postAccountActivate
  return axios.request({
    method: 'POST',
    url,
    data: payload,
    withCredentials: true,
    headers: {
      'X-CSRF-Token': token,
      "X-Transaction-ID": getTransactionId(),
    }
  })
}
